import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Breadcrumb } from './models/breadcrumbs.type';
import { LinkComponent } from '../../link/link.component';
import { SanitizeHtmlPipe } from '../../umbraco-blocks/pipes/sanitize-html.pipe';

@Component({
    selector: 'nw-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styleUrls: ['./breadcrumbs.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [LinkComponent, SanitizeHtmlPipe]
})
export class BreadcrumbsComponent {
    @Input() breadcrumbs?: Breadcrumb[];
}
